// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_JUiLE {
  position: fixed;
  height: 100vh;
  width: 100vw;

  background-color: transparent;
  top: 0;
  left: 0;
  z-index: 999;
}
.dropdownContainer_pTu9s {
  position: relative;
  display: inline-block;
  font-size: 12px;
  min-width: 200px;
  @media (width<=298px) {
    width: fit-content;
    min-width: fit-content;
  }
  .filterSort_BsWnc {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    .chevronIcon__Faok {
      width: 8px;
      height: 8px;
    }
    b{
      color: var(--_6-color);
    }
  }
  .dropdownOptions_lJiJT {
    position: absolute;
    width: 100%;
    margin-top: 4px;
    background: var(--white-background);
    border-radius: 10px;
    box-shadow: 0px 4px 8px var(--_0000001a-shadow);
    z-index: 1000;
    overflow: hidden;
    min-width: 200px;
    right: 0;
    .dropdownOption_EuPUI {
      padding: 8px 12px;
      font-size: 12px;
      font-weight: 500;
      color: var(--_9c9d9f-color);
      display: flex;
      align-items: center;
      gap: 5px;
      cursor: pointer;
      transition: background-color 0.2s;
      -webkit-transition: background-color 0.2s;
      -moz-transition: background-color 0.2s;
      -ms-transition: background-color 0.2s;
      -o-transition: background-color 0.2s;

      &:hover {
        background-color: var(--ececf1-border);
      }
    }
  }
  .subOptions_c7AmU {
    max-height: 40vh;
    overflow-y: auto;
  }

  .subOptions_c7AmU::-webkit-scrollbar {
    display: none;
  }

  .customDateInput_KTTmX {
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .customDateInput_KTTmX input {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    padding: 10px;
    border: 1px solid var(--ccc-border);
    border-radius: 4px;
    background-color: var(--white-background);
    width: 100%;
    max-width: 250px;
    transition: all 0.3s ease;
  }

  .customDateInput_KTTmX input:focus {
    outline: none;
    box-shadow: 0 0 5px var(--customDateInput-shadow);
  }

  .customDateInput_KTTmX input::placeholder {
    color: var(--888-contacts-color);
    font-size: 14px;
  }
  .sortBy_LCXXP {
    color: var(--_6-color);
    @media (width<=298px) {
      display: none;
    }
  }
  .searchIconsWrappers_JA63P {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
  margin-left: 5px;
}
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/FiltersDropdownContainer/FiltersDropdownContainer.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,YAAY;;EAEZ,6BAA6B;EAC7B,MAAM;EACN,OAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB;IACE,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf;MACE,UAAU;MACV,WAAW;IACb;IACA;MACE,sBAAsB;IACxB;EACF;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,mCAAmC;IACnC,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR;MACE,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,2BAA2B;MAC3B,aAAa;MACb,mBAAmB;MACnB,QAAQ;MACR,eAAe;MACf,iCAAiC;MACjC,yCAAyC;MACzC,sCAAsC;MACtC,qCAAqC;MACrC,oCAAoC;;MAEpC;QACE,sCAAsC;MACxC;IACF;EACF;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,iDAAiD;EACnD;;EAEA;IACE,gCAAgC;IAChC,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB;MACE,aAAa;IACf;EACF;EACA;EACA,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA","sourcesContent":[".bg {\n  position: fixed;\n  height: 100vh;\n  width: 100vw;\n\n  background-color: transparent;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}\n.dropdownContainer {\n  position: relative;\n  display: inline-block;\n  font-size: 12px;\n  min-width: 200px;\n  @media (width<=298px) {\n    width: fit-content;\n    min-width: fit-content;\n  }\n  .filterSort {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    .chevronIcon {\n      width: 8px;\n      height: 8px;\n    }\n    b{\n      color: var(--_6-color);\n    }\n  }\n  .dropdownOptions {\n    position: absolute;\n    width: 100%;\n    margin-top: 4px;\n    background: var(--white-background);\n    border-radius: 10px;\n    box-shadow: 0px 4px 8px var(--_0000001a-shadow);\n    z-index: 1000;\n    overflow: hidden;\n    min-width: 200px;\n    right: 0;\n    .dropdownOption {\n      padding: 8px 12px;\n      font-size: 12px;\n      font-weight: 500;\n      color: var(--_9c9d9f-color);\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      cursor: pointer;\n      transition: background-color 0.2s;\n      -webkit-transition: background-color 0.2s;\n      -moz-transition: background-color 0.2s;\n      -ms-transition: background-color 0.2s;\n      -o-transition: background-color 0.2s;\n\n      &:hover {\n        background-color: var(--ececf1-border);\n      }\n    }\n  }\n  .subOptions {\n    max-height: 40vh;\n    overflow-y: auto;\n  }\n\n  .subOptions::-webkit-scrollbar {\n    display: none;\n  }\n\n  .customDateInput {\n    margin-top: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .customDateInput input {\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    padding: 10px;\n    border: 1px solid var(--ccc-border);\n    border-radius: 4px;\n    background-color: var(--white-background);\n    width: 100%;\n    max-width: 250px;\n    transition: all 0.3s ease;\n  }\n\n  .customDateInput input:focus {\n    outline: none;\n    box-shadow: 0 0 5px var(--customDateInput-shadow);\n  }\n\n  .customDateInput input::placeholder {\n    color: var(--888-contacts-color);\n    font-size: 14px;\n  }\n  .sortBy {\n    color: var(--_6-color);\n    @media (width<=298px) {\n      display: none;\n    }\n  }\n  .searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n  margin-left: 5px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_JUiLE`,
	"dropdownContainer": `dropdownContainer_pTu9s`,
	"filterSort": `filterSort_BsWnc`,
	"chevronIcon": `chevronIcon__Faok`,
	"dropdownOptions": `dropdownOptions_lJiJT`,
	"dropdownOption": `dropdownOption_EuPUI`,
	"subOptions": `subOptions_c7AmU`,
	"customDateInput": `customDateInput_KTTmX`,
	"sortBy": `sortBy_LCXXP`,
	"searchIconsWrappers": `searchIconsWrappers_JA63P`
};
export default ___CSS_LOADER_EXPORT___;
